import { Grid } from "@mui/material";
import React, { useEffect } from "react";
import UserManagement from "./userManagement/userManagement";
import ClientManagement from "./clientManagement/clientManagement";

import SalesRepManagement from "./salesRepManagement/salesRepManagement";
import ProductManagement from "./productManagement/productManagement";
import { useAppDispatch, useAppSelector } from "../../../hooks/hooks";
import {
  getClientPlan,
  getClientType,
  getClientUserTitle,
  getClients,
  getPlans,
  getPrograms,
  getRoles,
} from "../../../store/thunks/systemManagementThunk";
import { useNavigate } from "react-router-dom";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { portalManagementReset } from "../../../store/features/portalManagement/portalManagementSlice";
import ClientUpload from "./clientUpload/clientUpload";
import PortalShell from "../../commonComponents/appShell/portalShell";
import { useShellNav } from "../../commonComponents/appShell/shellNav";
const userQueryClient = new QueryClient();

const productQueryClient = new QueryClient();
const salesRepQueryClient = new QueryClient();

const SystemManagementContent = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { user, loggedIn } = useAppSelector(
    (state: any) => state.authentication
  );

  const { selectedItemId: selectedNavigation } = useShellNav();

  useEffect(() => {
    if (loggedIn) {
      if (
        user.role_index === 100 ||
        user.role_index === 101 ||
        user.role_index === 102
      ) {
        // getUsers is NOT dispatched here. userManagement owns it through its
        // own query, and emailNotification fetches it when the store is empty.
        // Doing it here as well fired two identical /api/users on every visit,
        // and their fulfilment order decided what the user list showed.
        dispatch(getClients({}));
        dispatch(getRoles({}));
        // getProducts is NOT dispatched here either: nothing reads the
        // products slice, both consumers use the thunk's own payload, and
        // productManagement / attachSubscriptionDialog each fetch when shown.
        dispatch(getPrograms({}));
        dispatch(getPlans({}));
        dispatch(getClientPlan({}));
        dispatch(getClientType({}));
        dispatch(portalManagementReset());
        dispatch(getClientUserTitle({}));
      } else {
        navigate("/dashboard");
      }
    } else {
      navigate("/login");
    }
  }, []);

  // Rail visibility is gated by SYSTEM_NAV.roles in models/navigation.ts, so
  // there are deliberately no role checks left in this JSX.
  return (
    <Grid container>
      <Grid item xs={12}>
        {selectedNavigation === "user" && (
          <QueryClientProvider client={userQueryClient}>
            <UserManagement />
          </QueryClientProvider>
        )}
        {selectedNavigation === "client" && <ClientManagement />}
        {selectedNavigation === "subscription" && (
          <QueryClientProvider client={productQueryClient}>
            <ProductManagement />
          </QueryClientProvider>
        )}
        {selectedNavigation === "sales_rep" && (
          <QueryClientProvider client={salesRepQueryClient}>
            <SalesRepManagement />
          </QueryClientProvider>
        )}
        {selectedNavigation === "client_upload" && <ClientUpload />}
      </Grid>
    </Grid>
  );
};

const SystemManagementView = () => (
  <PortalShell system>
    <SystemManagementContent />
  </PortalShell>
);

export default SystemManagementView;
